// extracted by mini-css-extract-plugin
export default {"cost":"styles_cost__Xb1jf","switch":"styles_switch__LfVdG"};